"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.borderTop = exports.borderRight = exports.borderRadius = exports.borderLeft = exports.borderColor = exports.borderBottom = exports.border = void 0;
var _compose = _interopRequireDefault(require("./compose"));
var _style = require("./style");
const themeColorKey = 'busbud.colors';

// There is a bug in MUI/JSS were setting border and border-color properties
// cause some layout issue due to how JSS order CSS properties.
// Let's say you'll define a component Box with a red bottom border:
//
// <Box borderBottom='sm' borderColor="red" />
//
// MUI system lib will output 2 CSS defintion:
// - border-bottom: '1px solid'
// - border-color: 'red'
//
// In Css, 'border-bottom' is composed of 3 parts, width, style and color. On the
// example above, only width and style are defined. Thus the color value is
// the default one (currentcolor):
//
// - border-bottom: '1px solid currentcolor'
// - border-color: 'red'
//
// Now, JSS sorts CSS definitions according to their property name's lengths:
// border < border-top < border-color < border-bottom
// Our Box CSS will be:
//
// - border-color: 'red'
// - border-bottom: '1px solid currentcolor'
//
// CSS defintion order matters when browsers render a web page. Here, our bottom
// border will be of currentcolor (parent border color, or black if none set)
// instead red.
//
// This function solve it by combing border and borderColor props into a single
// border css declaration.
//
// JSS sorting: https://github.com/cssinjs/jss/blob/master/packages/jss-plugin-props-sort/src/index.js
// MUI issue: https://github.com/mui-org/material-ui/issues/16995
function getBorder(value, props) {
  const has_em_unit = typeof value === 'string' && value.substr(value.length - 2) === 'em';
  if (typeof value !== 'number' && !has_em_unit) {
    return value;
  }
  const colorKey = props.borderColor || 'border.primary.opaque';
  const borderColor = (0, _style.getPath)(props.theme, `${themeColorKey}.${colorKey}`);
  const value_with_unit = has_em_unit ? value : `${value}px`;
  return `${value_with_unit} solid ${borderColor}`;
}
const border = exports.border = (0, _style.style)({
  prop: 'border',
  themeKey: 'busbud.styles.borderWidth',
  transform: getBorder
});
const borderTop = exports.borderTop = (0, _style.style)({
  prop: 'borderTop',
  themeKey: 'busbud.styles.borderWidth',
  transform: getBorder
});
const borderRight = exports.borderRight = (0, _style.style)({
  prop: 'borderRight',
  themeKey: 'busbud.styles.borderWidth',
  transform: getBorder
});
const borderBottom = exports.borderBottom = (0, _style.style)({
  prop: 'borderBottom',
  themeKey: 'busbud.styles.borderWidth',
  transform: getBorder
});
const borderLeft = exports.borderLeft = (0, _style.style)({
  prop: 'borderLeft',
  themeKey: 'busbud.styles.borderWidth',
  transform: getBorder
});
const borderColor = exports.borderColor = (0, _style.style)({
  prop: 'borderColor',
  themeKey: themeColorKey,
  transform: () => ''
});
const borderRadius = exports.borderRadius = (0, _style.style)({
  prop: 'borderRadius',
  themeKey: 'busbud.styles.rounding'
});
const borders = (0, _compose.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
var _default = exports.default = borders;